// Enums are dictionary of names versus numbers. This is so they work in the same way as C# enums (and other languages) which allow multiple names to have the same number.

let toggleHandleColorEnum = {
    '#EF6662': 1,
    '#20993E': 2,
    '#FCA146': 3,
    '#5677FC': 4,
    '#B783DF': 5,
    '#FF8CEF': 6,
    '#FFEE32': 7
};

export default toggleHandleColorEnum;
